import { Link } from "react-router-dom";

interface ObjectIdentityTitleProps {
  objectId?: string;
  cospar?: string;
  name?: string;
  norad?: string;
  className?: string;
  linkToObject?: boolean;
  meta?: string;
  metaTitle?: string;
  variant?: "compact" | "inline";
}

export const ObjectIdentityTitle = ({
  className = "",
  cospar = "-",
  objectId,
  linkToObject = false,
  meta,
  metaTitle,
  name = "-",
  norad = "-",
  variant = "inline",
}: ObjectIdentityTitleProps) => {
  const nameValue = name || "-";
  const noradValue = norad || "-";
  const cosparValue = cospar || "-";
  const canLink = linkToObject && objectId !== undefined && objectId !== "-";
  const content =
    variant === "compact" ? (
      <div className={`min-w-0 max-w-full ${className}`}>
        <div className="truncate text-sm font-semibold text-slate-950">
          {nameValue}
        </div>
        <div className="mt-0.5 truncate text-xs font-medium text-slate-500">
          {noradValue} | {cosparValue}
        </div>
        {meta && (
          <div
            className="mt-0.5 whitespace-nowrap text-[11px] font-medium text-slate-500 truncate"
            title={metaTitle ?? meta}
          >
            {meta}
          </div>
        )}
      </div>
    ) : (
      <span className={`flex min-w-0 flex-col gap-0.5 ${className}`}>
        <span className="inline-flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-1">
          <span className="font-semibold text-slate-950">{nameValue}</span>
          <span className="text-sm font-medium text-slate-500">
            {noradValue} | {cosparValue}
          </span>
        </span>
        {meta && (
          <span
            className="truncate text-xs font-medium text-slate-500"
            title={metaTitle ?? meta}
          >
            {meta}
          </span>
        )}
      </span>
    );

  if (!canLink) {
    return variant === "compact" ? (
      content
    ) : (
      <span className="inline-flex min-w-0 max-w-full">{content}</span>
    );
  }

  return (
    <Link
      className={
        variant === "compact"
          ? "block min-w-0 max-w-full rounded-md px-1 py-0.5 transition hover:bg-slate-100 hover:no-underline"
          : "inline-flex min-w-0 max-w-full rounded-md px-1.5 py-1 transition hover:bg-slate-100 hover:no-underline"
      }
      to={`/catalogue/${objectId}/info`}
    >
      {content}
    </Link>
  );
};
